<template>
  <div>
    <bread-crumb-cas
      :routeList="breadArray"
      labelType="common"
    ></bread-crumb-cas>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    ></top-bar>
    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 32%; margin-left: 20px"
          v-model="searchParam"
          placeholder="请输入活动名称"
          clearable
        ></el-input>
        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <circle-table
      :tableData="tableData"
      @handleClick="handleClick"
    ></circle-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <el-drawer
      :visible.sync="dialogShowLabel"
      direction="rtl"
      size="40%"
      :destroy-on-close="true"
      :title="title"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="addClickHandler"
      @one="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form
          :rules="rules"
          :model="formList"
          label-width="120px"
          ref="formList"
        >
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              v-model="formList.activityName"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
              required
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动排序" prop="rankNum">
            <el-input
              v-model.number="formList.rankNum"
              class="base-dialog-input"
              autocomplete="off"
              type="number"
              placeholder="请输入"
              show-word-limit
              required
              @input="validateRankNum"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="是否对外显示" prop="isShow">
            <el-radio-group v-model="formList.isShow">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="关联标签" prop="labelId">
            <el-select
              v-model="formList.labelIds"
              filterable
              remote
              placeholder="请选择关联标签"
              :remote-method="remoteMethod"
              clearable
              multiple
              @focus="remoteMethodInit"
              multiple-limit="20"
            >
              <el-option
                v-for="item in labelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="自动选帖" prop="isAutoOnlineOfflinePost">
            <el-switch
              v-model="formList.isAutoOnlineOfflinePost"
              @change="autoOnlineHandle"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="流入规则"
            v-if="formList.isAutoOnlineOfflinePost"
          >
            <el-form-item
              label="帖子类型"
              prop="autoOnlineConfig.includePostTypeList"
            >
              <el-select
                v-model="formList.autoOnlineConfig.includePostTypeList"
                multiple
                placeholder="请输入帖子类型"
                style="width: 200px"
              >
                <el-option
                  v-for="item in optionsIncludePostTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="帖子等级"
              prop="autoOnlineConfig.includePostLevelList"
            >
              <el-select
                v-model="formList.autoOnlineConfig.includePostLevelList"
                multiple
                placeholder="请输入帖子类型"
                style="width: 200px"
              >
                <el-option
                  v-for="item in optionsIncludePostLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="圈子名称"
              prop="autoOnlineConfig.includeCommunityIdList"
            >
              <el-select
                v-model="formList.autoOnlineConfig.includeCommunityIdList"
                multiple
                placeholder="请选择圈子名称"
                style="width: 200px"
                filterable
                remote
                reserve-keyword
                :remote-method="communityMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in optionsIncludePostCircleList"
                  :key="item.value"
                  :label="item.communityName"
                  :value="item.communityId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item
            label="流出规则"
            v-if="formList.isAutoOnlineOfflinePost"
          >
            <el-form-item
              label="评论数量 >="
              prop="autoOfflineConfig.commentCountGte"
            >
              <el-input
                v-model="formList.autoOfflineConfig.commentCountGte"
                class="base-dialog-input"
                autocomplete="off"
                type="number"
                placeholder="请输入"
                show-word-limit
                required
                style="width: 200px"
              ></el-input>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="handleCancelActivateLabel">取消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              handleActivateLabel(title);
            }
          "
        >
          确定</el-button
        >
      </div>
    </el-drawer>
    <modal
      :isShow.sync="moveDialog"
      title="移动"
      :isShowBtn="isShowBtn"
      :btnText="mergeMoveBtnText"
      @clickHandler="moveClickHandler"
      width="800px"
    >
      <ContentLabelCascader
        :labelType="1"
        :selectedId="tableVal.id"
        :functionIds="{
          getArticleLabel: 'health_cmp_biz_pageAuditLabels',
          operateApi: 'health_cmp_moveContentLabel',
        }"
        ref="moveSelectedRef"
      />
    </modal>
    <modal
      :isShow.sync="mergeDialog"
      title="合并"
      :isShowBtn="isShowBtn"
      :btnText="mergeMoveBtnText"
      @clickHandler="mergeClickHandler"
    >
      <ContentLabelCascader
        :labelType="1"
        :selectedId="tableVal.id"
        :functionIds="{
          getArticleLabel: 'health_cmp_biz_pageAuditLabels',
          operateApi: 'health_cmp_mergeContentLabel',
        }"
        ref="moveSelectedRef"
      />
    </modal>
    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal
      :isShow.sync="attributeShow"
      title="属性"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="btnTextClickHandler"
    >
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox
            v-for="item in checkList"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </modal>
  </div>
</template>

<script>
import circleTable from "./circleTable.vue";
import pagination from "../../../../../components/pagination";
import topBar from "../../../../../components/topBar";
import baseTable from "@/components/baseTable";
import ContentLabelCascader from "@/components/select/ContentLabelCascader";
import breadCrumbCas from "../../../../../components/breadCrumb.vue";
import modal from "../../../../../components/modal";
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import { jdh_qz_man_post_label_page } from "../../../../../api/community";
import {
  saveOrUpdateLabelGroup,
  getTagAttributes,
  jdh_qz_man_activity_add,
  jdh_qz_man_activity_update,
  jdh_qz_man_activity_page,
  jdh_qz_man_query_post_level_enum,
  jdh_qz_man_query_post_type_enum,
  jdh_qz_man_page,
} from "../../../../../api/man.js";
import { mapState } from "vuex";
import { uploadFile } from "@/utils/axios";
import { getBusinessId } from "../../../../../utils/enum";

export default {
  name: "commonLabel",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入名称"));
      } else {
        callback();
      }
    };
    return {
      optionsIncludePostTypeList: [],
      optionsIncludePostLevelList: [],
      optionsIncludePostCircleList: [],
      attributeShow: false, // 属性弹窗
      checkList: [
        {
          id: 2,
          name: "写手端不可见",
        },
        {
          id: 3,
          name: "C端用户不可见",
        },
      ],
      checkedCities: [],
      title: "",
      isRed: false,
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "活动ID",
            prop: "activityId",
            width: "120px",
          },
          {
            label: "活动名称",
            prop: "activityName",
            width: "120px",
          },
          {
            label: "活动分类",
            prop: "categoryName",
          },
          {
            label: "活动排序",
            prop: "rankNum",
            width: "80px",
          },
          {
            label: "关联标签",
            prop: "rowLabelList",
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: "120px",
          },
          {
            label: "创建人",
            prop: "createUser",
            width: "120px",
          },
          {
            label: "是否对外显示",
            prop: "isShow",
            width: "100px",
          },
          {
            label: "是否自动选帖子",
            prop: "isAutoOnlineOfflinePost",
            width: "100px",
          },
        ],
        tableType: 4,
      },
      isShowSelect: false,

      labelList: [],
      // 删除弹框
      deleteDialog: false,
      data: [],
      times: null,
      tableVal: {},
      btnText: ["取消", "确认"],
      // 移动弹框
      moveDialog: false,
      // 合并弹框
      mergeDialog: false,
      mergeMoveBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      activityName: "",
      dialogShow: false,
      dialogShowLabel: false,
      formList: {
        activityName: "",
        rankNum: 0,
        labelIds: [],
        isShow: 0,
        isAutoOnlineOfflinePost: false,
        autoOnlineConfig: {
          includePostTypeList: [],
          includePostLevelList: [],
          includeCommunityIdList: [],
        },
        autoOfflineConfig: {
          commentCountGte: undefined,
        },
      },
      rules: {
        activityName: [{ validator: validatePass, trigger: "blur" }],
        rankNum: [{ validator: validatePass, trigger: "blur" }],
        isShow: [{ validator: validatePass, trigger: "blur" }],
      },
      rules: {
        activityName: [
          { required: true, message: "活动名称不得为空", trigger: "change" },
        ],
        rankNum: [
          { required: true, message: "活动排序不得为空", trigger: "change" },
        ],
        isShow: [
          { required: true, message: "必选是否显示", trigger: "change" },
        ],
      },
      invisibleStatus: "",
      breadArray: [
        {
          name: "标签管理",
          path: "",
          query: undefined,
        },
        {
          name: "通用标签",
          path: "/commonLabel/group",
          query: this.$router.query,
        },
      ],
      titlePicUrl: [],
      imgHost: process.env.VUE_APP_imgHost,
      searchParam: "",
    };
  },
  components: {
    baseTable,
    circleTable,
    topBar,
    breadCrumbCas,
    modal,
    pagination,
    ContentLabelCascader,
    uploadImgUniversal,
  },
  watch: {
    "formList.activityName"(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formList.activityName = this.$utils.removalSpace(newValue);
      }
    },
    formList: {
      handler(newValue, oldValue) {
        this.isRed = false;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    communityMethod(query) {
      if (query !== "") {
        this.loading = true;
        jdh_qz_man_page({
          pageNo: 1,
          pageSize: 100,
          tenantId: this.$commonJs.getTenantId(),
          businessId: this.getBusinessId(this.$commonJs.getTenantId()),
          status: 1,
          communityNameKeyword: query,
        }).then((ret) => {
          this.loading = false;
          this.optionsIncludePostCircleList = [...ret.data];
        });
      } else {
        this.optionsIncludePostCircleList = [
          ...this.optionsIncludePostCircleList,
        ];
      }
    },
    getOptions(row) {
      console.log(row, "row");
      jdh_qz_man_query_post_type_enum({}).then((ret) => {
        this.optionsIncludePostTypeList = [...ret];
      });

      jdh_qz_man_query_post_level_enum({}).then((ret) => {
        this.optionsIncludePostLevelList = [...ret];
      });

      jdh_qz_man_page({
        pageNo: 1,
        pageSize: 100,
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        status: 1,
        communityType: 3,
        appendCommunityIds: row?.autoOnlineConfig?.includeCommunityIdList || [],
      }).then((ret) => {
        this.optionsIncludePostCircleList = ret.data;
      });
    },
    includePostTypeListRemoteMethod(query) {},
    autoOnlineHandle(event) {
      console.log(event);
    },
    remoteMethod(query) {
      jdh_qz_man_post_label_page({
        pageNo: 1,
        pageSize: 200,
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        labelName: query,
      }).then((res) => {
        console.log("query labelList", res);
        this.labelList = (res.data || [])?.map((item) => ({
          value: item.labelId,
          label: item.labelName,
        }));
      });
    },
    remoteMethodInit() {
      jdh_qz_man_post_label_page({
        pageNo: 1,
        pageSize: 500,
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
      }).then((res) => {
        console.log("query labelList", res);
        this.labelList = (res.data || [])?.map((item) => ({
          value: item.labelId,
          label: item.labelName,
        }));
      });
    },
    validateRankNum() {
      // 将 rankNum 取整并限制在 0 到 100 之间
      this.formList.rankNum = Math.floor(this.formList.rankNum); // 取整
      if (this.formList.rankNum > 100) {
        this.formList.rankNum = 100; // 限制最大值为 100
      }
      if (this.formList.rankNum < 0) {
        this.formList.rankNum = 0; // 可选：限制最小值为 0
      }
    },
    handleSearch() {
      this.jdh_qz_man_activity_page(this.searchParam);
    },
    handleReset() {
      this.jdh_qz_man_activity_page();
      this.searchParam = "";
    },
    uploadFileEditor(file, callback) {
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
        // this.setStoragePropertyByName(storageProperty, uploadImageList);
      })
        .then((res) => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
        })
        .catch((error) => {
          file.status = "reject";
          this.$message.error("图片上传失败");
        });
    },
    httpRequestEditor(request) {
      this.uploadFileEditor(request.file, (msg) => {
        let url = `//image.healthjd.com/da/` + msg;
        let html = '<img style="max-width:100%" src="' + url + '" />';
        this.editor.insertContent(html);
      });
    },
    // 获取businessId
    getBusinessId(key) {
      return getBusinessId(key);
    },
    changeCheck(val) {
      let numStatus = val.toString();
      let numStr1 = "2,3";
      let numStr2 = "3,2";
      if (numStatus == numStr1 || numStatus == numStr2) {
        this.invisibleStatus = 4;
      } else {
        this.invisibleStatus = numStatus;
      }
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === "one") {
        this.attributeShow = false;
        this.checkedCities = [];
      } else if (val === "two") {
        if (this.invisibleStatus == "") {
          this.invisibleStatus = "1";
        }
        getTagAttributes({
          tenantId: this.tableVal.tenantId,
          id: this.tableVal.id,
          invisibleStatus: this.invisibleStatus,
          // updateInvisibleStatusType: this.tableVal.yn
        })
          .then((res) => {
            if (res) {
              this.checkedCities = [];
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.attributeShow = false;
            }
            this.jdh_qz_man_activity_page();
          })
          .catch((err) => {
            this.$message.error("操作失败");
          });
        this.attributeShow = false;
      }
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.jdh_qz_man_activity_page();
    },
    handleClick(val) {
      this.getOptions(val?.val);
      if (val.type === "edit") {
        console.log("==== edit", val.val);
        this.labelList = (val.val?.labelList || [])?.map((item) => ({
          value: item.labelId,
          label: item.labelName,
        }));
        this.dialogShowLabel = true;
        this.title = "编辑";
        this.formList = {
          ...this.formList,
        };
        setTimeout(() => {
          if (val.val?.isShow == "是") {
            this.formList = {
              ...this.formList,
              ...val.val,
              isShow: 1,
            };
          } else if (val.val?.isShow == "否") {
            this.formList = {
              ...this.formList,
              ...val.val,
              isShow: 0,
            };
          } else {
            this.formList = {
              ...this.formList,
              ...val.val,
            };
          }
        }, 200);
      } else if (val.type === "goAdmin") {
        // 跳转标签下帖子
        this.$router.push({
          path: `/eventPostManage`,
          query: {
            activityId: val.val.activityId,
            activityName: val.val.activityName,
          },
        });
      } else if (val.type === "delete") {
        this.deleteDialog = true;
        this.formList = {
          ...this.formList,
          ...val.val,
        };
      } else if (val.type === "attribute") {
        this.attributeShow = true;
        this.tableVal = val.val;
        // 属性值回显
        if (val.val.invisibleStatus !== 1) {
          if (val.val.invisibleStatus == 4) {
            this.checkedCities = [2, 3];
          } else {
            this.checkedCities = [val.val.invisibleStatus];
          }
        }
        this.invisibleStatus = val.val.invisibleStatus;
      } else if (val.type === "moveLabel") {
        this.moveDialog = true;
        this.tableVal = val.val;
      } else if (val.type === "mergeLabel") {
        this.mergeDialog = true;
        this.tableVal = val.val;
      }
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteDialog = false;
      } else if (val === "two") {
        this.jdh_qz_man_activity_update({
          ...this.formList,
          status: 2,
        });
        // this.deleteDialog=false
      }
    },
    // 删除
    jdh_qz_man_activity_update(val) {
      console.log("==== delete", val);
      jdh_qz_man_activity_update({
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        activityId: val.activityId,
        isShow: val.isShow == "是" ? 1 : 0,
        status: 2,
      })
        .then((res) => {
          if (res) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
          this.deleteDialog = false;
          this.paginationDataProduct.currentPage = 1;
          this.jdh_qz_man_activity_page();
        })
        .catch((res) => {
          // if(res.data===-1) {
          this.$message.error(res.msg);
          // }
        });
    },
    // 新增弹框
    handleCancelActivateLabel() {
      this.dialogShowLabel = false;
    },
    async handleActivateLabel(val) {
      await this.$refs["formList"].validate((valid) => {
        if (valid) {
          console.log("submit!");
          val == "新增"
            ? jdh_qz_man_activity_add({
                tenantId: this.$commonJs.getTenantId(),
                businessId: this.getBusinessId(this.$commonJs.getTenantId()),
                activityName: this.formList.activityName,
                categoryId: this.$route.query?.categoryId || "",
                rankNum: this.formList?.rankNum || 0,
                labelIds: this.formList?.labelIds || [],
                isShow: this.formList.isShow,
                status: 1,
                isAutoOnlineOfflinePost: this.formList?.isAutoOnlineOfflinePost
                  ? 1
                  : 0,
                autoOnlineConfig: this.formList?.autoOnlineConfig,
                autoOfflineConfig: this.formList?.autoOfflineConfig,
              }).then((res) => {
                (this.dialogShowLabel = false), this.jdh_qz_man_activity_page();
              })
            : jdh_qz_man_activity_update({
                tenantId: this.$commonJs.getTenantId(),
                businessId: this.getBusinessId(this.$commonJs.getTenantId()),
                activityName: this.formList.activityName,
                activityId: this.formList.activityId,
                rankNum: this.formList?.rankNum || 0,
                labelIds: this.formList?.labelIds || [],
                isShow: this.formList.isShow,
                status: 1,
                isAutoOnlineOfflinePost: this.formList?.isAutoOnlineOfflinePost
                  ? 1
                  : 0,
                autoOnlineConfig: this.formList?.autoOnlineConfig,
                autoOfflineConfig: this.formList?.autoOfflineConfig,
              }).then((res) => {
                (this.dialogShowLabel = false), this.jdh_qz_man_activity_page();
              });
        } else {
          console.log("error submit!");
          this.$message.error("请填写完整");
        }
      });
    },
    // 合并弹框
    mergeClickHandler(val) {
      if (val === "one") {
        this.mergeDialog = false;
      } else if (val === "two") {
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    // 移动弹框
    moveClickHandler(val) {
      if (val === "one") {
        this.moveDialog = false;
      } else if (val === "two") {
        // this.jdh_qz_man_post_label_delete(this.tableVal)
        console.log(this.$refs, 9999);
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    // 分页
    jdh_qz_man_activity_page(searchParam) {
      let vm = this;
      jdh_qz_man_activity_page({
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        categoryId: this.$route.query?.categoryId,
        status: 1,
        activityName: searchParam ? searchParam : "",
      }).then((res) => {
        console.log("🚀 ~ jdh_qz_man_activity_page ~ res:", res);
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.updateTime = this.formatDate(item.updateTime);
          item.createTime = this.formatDate(item.createTime);
          item.isShow = item.isShow ? "是" : "否";
          if (!item.rowLabelList) {
            item.rowLabelList = [];
          }
          item?.labelList?.map((l) => {
            console.log("==== l", l);
            item.rowLabelList.push({ label: l?.labelName, value: l?.labelId });
          });
          console.log("==== item", item);
          this.tableData.tableList.push(item);
        });
        vm.paginationDataProduct.total = res.totalCount;
        vm.paginationDataProduct.currentPage = res.pageNo;
        vm.paginationDataProduct.pageSize = res.pageSize;
      });

      // jdh_qz_man_query_post_type_enum
    },
    clickAddButton() {
      this.title = "新增";
      this.getOptions(null);
      const newFormList = {
        activityName: "",
        rankNum: 0,
        labelIds: [],
        isShow: 0,
        isAutoOnlineOfflinePost: false,
        autoOnlineConfig: {
          includePostTypeList: [],
          includePostLevelList: [],
          includeCommunityIdList: [],
        },
        autoOfflineConfig: {
          commentCountGte: undefined,
        },
      };
      this.formList = {
        ...newFormList,
        activityName: "",
      };
      this.dialogShowLabel = true;
    },
    handleDialog(val) {
      this.dialogShow = val;
    },
    handleDialogLabel(val) {
      // dialogShowLabel
      this.dialogShowLabel = val;
    },
    handleDialogSubmit() {
      this.handleDialog(false);
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false);
    },
    // 新增
    saveOrUpdateLabelGroup(name) {
      saveOrUpdateLabelGroup({
        id: this.tableVal.id == undefined ? "" : this.tableVal.id,
        labelType: 1,
        name: name,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          this.isRed = false;
          this.dialogShowLabel = false;
          this.jdh_qz_man_activity_page();
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },
  },
  created() {
    this.jdh_qz_man_activity_page();
  },
};
</script>

<style lang="scss" scoped>
.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 30px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    :deep(.el-input) {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 100%;
  height: 70vh;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;
  overflow-y: auto;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  :deep(.el-form-item__label) {
    width: 68px;
    font-weight: bolder;
  }

  :deep(.el-input__inner) {
    height: 32px;
  }

  // :deep(.el-form-item__error) {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    :deep(.el-dialog__title) {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}

.base-dialog-input-border {
  position: relative;

  & > input {
    border: 1px solid #f56c6c;
  }
}

.rules {
  position: absolute;
  font-size: 0.5em;
  color: #f56c6c;
  bottom: -28px;
  left: 0px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}
</style>
